import { authCoreClient } from '@utils/api/base';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { processAxiosResponse } from '@utils/api/utils';
import useCognito from '@as_core/account/useCognito';
import { BugReportsParamsT, IBugReport } from '@as_core/bugsReporting/bugs.types';

export const BugReportsApi = {
  get: (token: string, config) =>
    authCoreClient(token).get('/bugs/', config),
  submit: (token: string, data) =>
    authCoreClient(token).post('/bugs/submit', data),
  update: (token: string, uuid, data) =>
    authCoreClient(token).patch(`/bugs/update/${uuid}`, data),
  delete: (token: string, uuid) =>
    authCoreClient(token).delete(`/bugs/delete/${uuid}`),
  addComment: (token: string, uuid, data) =>
    authCoreClient(token).patch(`/bugs/add/comment/${uuid}`, data),
};

const useBugReports = () => {
  const { getToken } = useCognito();

  const getBugReports = async (params: BugReportsParamsT): Promise<IBugReport[]> => {
    const config: AxiosRequestConfig = { params };
    let resp: AxiosResponse<IBugReport[]> = await BugReportsApi.get(getToken(), config);
    return processAxiosResponse('getBugReports', resp);
  };

  const createBugReport = async (params: BugReportsParamsT): Promise<IBugReport> => {
    let resp: AxiosResponse<IBugReport> = await BugReportsApi.submit(getToken(), params);
    return processAxiosResponse('createBugReport', resp);
  };

  const updateBugReport = async (
      bug_id: string,
      params: BugReportsParamsT
  ): Promise<IBugReport> => {
    const config: AxiosRequestConfig = { params };
    let resp: AxiosResponse<IBugReport> = await BugReportsApi.update(getToken(), bug_id, config);
    return processAxiosResponse('updateBugReport', resp);
  };

  const addBugReportComment = async (
    bug_id: string,
    comment: string
  ): Promise<IBugReport> => {
    const params = {"comment": comment};
    let resp: AxiosResponse<IBugReport> = await BugReportsApi.addComment(getToken(), bug_id, params);
    return processAxiosResponse('addBugReportComment', resp);
  };

  const deleteBugReport = async (
    bug_id: string,
  ): Promise<IBugReport> => {
    let resp: AxiosResponse<IBugReport> = await BugReportsApi.delete(getToken(), bug_id);
    return processAxiosResponse('deleteBugReport', resp);
  };

  return {
    getBugReports,
    createBugReport,
    updateBugReport,
    addBugReportComment,
    deleteBugReport
  };
}

export default useBugReports;
